
seedWebApp.controller('OrderCancelModalController', ['$scope', '$uibModalInstance', 'TranslationService', 'order',
    function OrderCancelModalController($scope, $uibModalInstance, TranslationService, order) {
        $scope.translation = TranslationService.getActiveTranslation();
        console.log('OrderCancelModalCtrl.order');
        //console.log(order);

        $scope.order = order;

        /*
        if (order.obs_rejeicao) {
            order.RejectComments = order.obs_rejeicao;
        }
        if (order.observacao) {
            order.AcceptComments = order.observacao;
        }
        */

        $scope.ok = function () {
            $uibModalInstance.close(order.CancelReason);
        };

        

        $scope.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }]
);